import Loadable from "app/components/Loadable";
import { lazy } from "react";

const DealerVisitList = Loadable(lazy(() => import("./DealerVisitList")));
const DealerVisitForm = Loadable(lazy(() => import("./DealerVisitForm")));

const dealerVisitRoutes = [
  {
    path: "/DealerVisit/DealerVisitList",
    element: <DealerVisitList />,
  },
  {
    path: "/DealerVisit/DealerVisitForm",
    element: <DealerVisitForm />,
  },
  {
    path: "/DealerVisit/DealerVisitForm/:dealerVisitId",
    element: <DealerVisitForm />,
  },
];
export default dealerVisitRoutes;
